(function () {
  console.log('Ready player ONE!');
  
  /*
  Ocultamos el tercer elemento del menu
  var header = document.querySelector('.header__list');
  var headerMobile = document.querySelector('.header-mobile__menu-main');
  
  if (header) {
      toggleThirdLiVisibility(header);
  }
  if (headerMobile) {
      toggleThirdLiVisibility(headerMobile);
  }
  
  function toggleThirdLiVisibility(container) {
      var thirdLi = container.querySelectorAll('li')[3]; // El tercer li tiene índice 2
      if (container.classList.contains('language-de')) {
          if (thirdLi) {
              thirdLi.style.display = 'block';
          }
      } else {
          if (thirdLi) {
              thirdLi.style.display = 'none';
          }
      }
  }
  */
})();